import { Components, Theme } from '@mui/material/styles';

const CHIP_COLORS = {
  chipSuccess: true,
  chipDanger: true,
} as const;

export const components: Components<Theme> = {
  MuiButtonBase: {
    defaultProps: {
      disableRipple: true,
      disableTouchRipple: true,
    },
  },

  MuiChip: {
    styleOverrides: {
      root: ({ ownerState, theme }) => {
        const color = ownerState.color as keyof typeof CHIP_COLORS | undefined;

        return {
          fontWeight: 500,
          borderRadius: '4px',
          fontSize: '14px',
          lineHeight: '16px',

          ...(color === 'chipSuccess' && {
            backgroundColor: theme.palette.success400.light,
            color: theme.palette.success600.main,
          }),

          ...(color === 'chipDanger' && {
            backgroundColor: theme.palette.error500.light,
            color: theme.palette.error600.main,
          }),
        };
      },
    },
  },

  MuiTextField: {
    styleOverrides: {
      root: ({ theme, ownerState }) => ({
        ...(ownerState.InputProps?.readOnly && {
          backgroundColor: theme.palette.inputReadonly.main,
        }),
      }),
    },
  },
  MuiCssBaseline: {
    styleOverrides: {
      '*::-webkit-scrollbar': {
        width: '8px',
        height: '8px',
      },

      '*::-webkit-scrollbar-track': {
        backgroundColor: '#EFF0F0',
      },

      '*::-webkit-scrollbar-thumb': {
        backgroundColor: '#A1A1A1',
        borderRadius: '8px',
        border: '2px solid #EFF0F0',
        height: '64px',
      },

      '*::-webkit-scrollbar-thumb:hover': {
        backgroundColor: '#A1A1A1',
      },
    },
  },
};
